import { render, staticRenderFns } from "./FormAnswerBlock.vue?vue&type=template&id=23bf227e&scoped=true"
import script from "./FormAnswerBlock.vue?vue&type=script&lang=js"
export * from "./FormAnswerBlock.vue?vue&type=script&lang=js"
import style0 from "./FormAnswerBlock.vue?vue&type=style&index=0&id=23bf227e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23bf227e",
  null
  
)

export default component.exports